<template>
  <div class="container-fluid">
    <div class="row">


      <!-- Right Panel -->
      <div class="col-md-4 item-right">
        <div class="form-container">
          <img src="/static/img/logo.png" id="brand-logo" />
          <h4>Sign Up</h4>


        <div>
          <form v-on:submit.prevent="login()">
            <div class="form-group">
              <input type="email" placeholder="Email" v-model="email" required>
            </div>
            <div class="form-group">
              <input type="password" placeholder="Password" v-model="password" required>
            </div>
            <div class="form-group">
              <button type="submit" :disabled="!isValidEmail">LOGIN</button>
            </div>
          </form>

          <transition name="fade">
            <p v-if="showPleaseWait == true">Please wait...</p>
          </transition>

          <transition name="fade">
            <h5 v-if="showMessage == true" class="error">
              {{displayMsg}}
            </h5>
          </transition>          


        </div>



        </div>
      </div>
    </div>
  </div>

</template>

<script>
import api from "../api";
import axios from "axios";
import { globalStore } from "../main.js";
// import jwt from 'jsonwebtoken';

const jwt = require('jsonwebtoken');
// import VueCookies from 'vue-cookies'

export default {
  name: "Login",
  data(router) {
    return {
      email: "",
      password: "",
      token: "",
      showPleaseWait: false,
      showMessage: false,
      displayMsg: ""
    }
  },
  computed: {
    isValidEmail() {
      // check if email is valid
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email);
    }
  },
  mounted() {

    console.log("Login Page Mounted");
    console.log(globalStore.url);

  },
  methods: {
    login(){


      this.showPleaseWait = true;

      console.log("Login");
      console.log(this.email);
      console.log(this.password);

      var payload = {
        confEmail: this.email,
        confPassword: this.password
      }

      axios.post(
        globalStore.url+ `/api/conf-login`, payload
        ).then(response => {
          console.log("Conf Login API Response");

          console.log(response);

          console.log("clientId: "+response.data.clientId);
          console.log("eventId: "+response.data._id);

          localStorage.setItem('clientId',response.data.clientId);
          localStorage.setItem('eventId',response.data._id);

          globalStore.clientId = response.data.clientId;
          globalStore.eventId = response.data._id;

          console.log("Hello...");

          this.$router.push("/");



        }).catch(e => {
          console.log("Error :"+JSON.stringify(e));

          // console.log("Error: "+e.response.data.message);

          console.log("Please Try Again.");

          this.showPleaseWait = false;
          this.showMessage = true;
          this.displayMsg = "Incorrect email & password combination. Please try again...";


        }); 

                

    }
  }
};
</script>

<style>
 
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

#brand-logo {
  width: 50%;
}

.container-fluid, 
.item-left,
.item-right {
  height: 100vh;
}

.item-left {
  /* border: 1px solid red; */
  background-color: #e8e8e8;
  display: flex;
  /* flex-direction: column;
  align-items: center;
  align-content: center;
  justify-content: center; */
  /* background-image: linear-gradient(
      rgba(3, 155, 229, 0.7),
      rgba(3, 155, 229, 0.7)
    ),
    url("/static/img/bg-2.jpg"); */
  background-image: url("/static/img/bg-4.jpeg");
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
}


.item-right {
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
  justify-content: center;
}

.form-container{
  align-self: center;
  align-content: center;
  text-align: center;
}


.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}


.form-group {
  margin-bottom: 15px;
}

input[type=email], input[type=password] {
  border-radius: 8px;
  padding: 10px;
  border: 1px solid #ccc;
  width: 100%;
  box-sizing: border-box;
}

input[type=email]::placeholder {
  border-radius: 8px;
  padding: 10px;
  border: none;
}

button {
  background-color: #ffffff;
  color: #000000;
  
  padding: 10px 20px;
  border: 1px solid #000000;
  border-radius: 8px;
  cursor: pointer;
  width: 100%;
}

button:hover {
  background-color: #131313;
  color: #ffffff;
  
  padding: 10px 20px;
  border: 1px solid #000000;
  border-radius: 8px;
  cursor: pointer;
  width: 100%;
}

button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  width: 100%;
}

</style>



// WEBPACK FOOTER //
// Signup.vue?e3b74d88